<template>
    <LayoutDefault title-page="Wizard de correspondencia de Exames">
        <b-card-group class="mb-2">
            <b-card header="Acoes" class="text-center">
                <router-link to="/tuevs/import" class="nav-link">
                    <b-button class="ml-1" variant="danger">Voltar</b-button>
                </router-link>
                <b-button class="ml-1" variant="primary" @click="prev()">Anterior</b-button>
                <b-button class="ml-1" variant="success" @click="map()">Salvar</b-button>
                <b-button class="ml-1" variant="primary" @click="next()">Proximo</b-button>
                <h2>{{ currentExam['status']}}</h2>
            </b-card>
        </b-card-group>
        <b-card-group>
            <b-card header="TUEVS">
                <b-form-group label="Busque na TUEVS" v-if="currentExam.status !== 'salvo'">
                    <v-select id="tuevs_exams_select" v-model="tuevs_exam_id" :options="tuevs_exams"
                              @search="query => search = query" trim v-if="currentTuevsExam === null"/>
                    <v-select id="tuevs_exams_select2" v-model="tuevs_exam_id"
                              :options="tuevsExamsOptionsForMultipleFound" @search="query => search = query" trim
                              v-if="currentTuevsExam !== null"/>
                </b-form-group>
                <ExamWizardForm v-if="currentTuevsExam instanceof Array" v-for="cte in currentTuevsExam" :key="cte['code']"
                                is-tuevs
                                collapse-id="tuevs"
                                :exam_name="cte['name']"
                                :exam_code="cte['code']"
                                :component="cte['teuvs_component_id']"
                                :material="cte['tuevs_material_id']"
                                :method="cte['tuevs_method_id']"
                                :time="cte['tuevs_time_id']"
                                :scale="cte['tuevs_scale_id']"
                ></ExamWizardForm>
            </b-card>
            <b-card header="Integracao">
                <ExamWizardForm
                        :exam_name="currentExam['mnemonico_exame']"
                        :exam_code="currentExam['nome_exame']"
                        :material="currentExam['mnemonico_material']"
                        :method="currentExam['mnemonico_metodo']"
                        :sub_exam_name="currentExam['nome_sub_exame']"
                        :sub_exam_code="currentExam['mnemonico_sub_exame']"
                ></ExamWizardForm>
            </b-card>
        </b-card-group>
    </LayoutDefault>
</template>

<script>
    import LayoutDefault from "@/templates/LayoutDefault";
    import ExamWizardForm from "@/components/tuevs/ExamWizardForm";
    import {mapActions, mapGetters} from "vuex";
    import vSelect from 'vue-select';


    export default {
        name: "Wizard",
        components: {LayoutDefault, ExamWizardForm, vSelect},
        props: ['items'],
        methods: {
            ...mapActions([
                'tuevs/getTuevsExams',
                'tuevs/mapExamToTuevs'
            ]),
            next() {
                this.tuevsExamsOptionsForMultipleFound
                this.tuevs_exam_id = null
                if (this.index >= this.max) {
                    this.index = this.max;
                } else {
                    this.index += 1;
                }
            },
            prev() {
                this.tuevs_exam_id = null

                this.tuevsExamsOptionsForMultipleFound

                if (this.index > 0) {
                    this.index -= 1;
                } else {
                    this.index = 0;
                }
            },
            map() {
                this['tuevs/mapExamToTuevs']({
                    mapped_exam_id: this.currentExam.id,
                    tuevs_id: this.tuevs_exam_id.code
                })
            }
        },
        data() {
            return {
                index: 0,
                max: 0,
                tuevs_exam_id: null
            }
        },
        mounted() {
            this.currentExam ?? this.$router.push({name: 'tuevs.import'})
            this.tuevs_exams.length == 0 ? this['tuevs/getTuevsExams'](this.search) : null;
        },
        computed: {
            ...mapGetters({
                examsToSync: 'tuevs/getExamsToSync',
                tuevs_exams: 'tuevs/getTuevsExams'
            }),
            filtered() {
                return this.tuevs_exams.filter(tuevs_exam => tuevs_exam.label.includes(this.search))
            },
            currentExam() {
                this.max = this.examsToSync.length - 1;
                return this.examsToSync[this.index];
            },
            currentTuevsExam() {
                return this.examsToSync[this.index]['tuevs_exam'];
            },
            tuevsExamsOptionsForMultipleFound() {
                if (this.currentTuevsExam && this.currentTuevsExam.length > 1) {
                    let options = [];
                    this.currentTuevsExam.forEach(item => {
                        options = [...options, {
                            code: item.id,
                            label: item.name
                        }]
                    })
                    return options;
                }
                return [];

            }
        }
    }
</script>

<style scoped>

</style>